<template>
  <div>专题管理</div>
</template>

<script>
export default {};
</script>

<style></style>
